import React from 'react';
import PropTypes from "prop-types";
import {loadDatosServicio} from "../../../dental/utils/FormularioUtils";

const nombreClase= "Poblacion";
const nombreServicio = "getLista";

class InputPoblacion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: props.valor || '',
            suggestions: [],
            loading: false,
            activeIndex: -1,
            isOpen: false,
            modified: false,
        };
        this.timeoutId = null;
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }

    handleClickOutside = (event) => {
        if (
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(event.target)
        ) {
            this.setState({ isOpen: false, activeIndex: -1 });
        }
    };

    handleChange = (e) => {
        const query = e.target.value;
        this.setState({ query, activeIndex: -1, modified: true });

        if (this.timeoutId) clearTimeout(this.timeoutId);

        if (query.trim() === '') {
            this.setState({ suggestions: [], isOpen: false });
            return;
        }

        if (!this.state.modified) return;

        // Debounce configurable (por defecto 300ms)
        const debounceTime = this.props.debounce || 300;
        let parametros= {provinciaCodigo: 46, nombreInicio: query};

        this.timeoutId = setTimeout(() => {
            this.setState({ loading: true });
            loadDatosServicio(this, "Poblacion", "getLista", parametros, (datos) => {
                console.log("Datos: ", datos);
                this.setState({
                    suggestions: datos,
                    loading: false,
                    activeIndex: -1,
                    isOpen: true,})
                },
                () => {
                    this.setState({ loading: false });

                }
            );
        }, debounceTime);
    };

    handleSelect = (value) => {
        this.setState({ query: value, suggestions: [], activeIndex: -1, isOpen: false });
        if (this.props.onSelect) this.props.onSelect(value);
    };

    handleKeyDown = (e) => {
        const { activeIndex, suggestions, isOpen } = this.state;
        if (!suggestions.length || !isOpen) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.setState(
                { activeIndex: (activeIndex + 1) % suggestions.length },
                this.scrollToActive
            );
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.setState(
                { activeIndex: (activeIndex - 1 + suggestions.length) % suggestions.length },
                this.scrollToActive
            );
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (activeIndex >= 0 && activeIndex < suggestions.length) {
                this.handleSelect(suggestions[activeIndex]["nombre"]);
            }
        } else if (e.key === 'Escape') {
            this.setState({ isOpen: false, activeIndex: -1 });
        }
    };

    scrollToActive = () => {
        const container = this.suggestionsContainer;
        const activeItem = container?.children[this.state.activeIndex];
        if (activeItem && container) {
            const itemTop = activeItem.offsetTop;
            const itemBottom = itemTop + activeItem.offsetHeight;
            if (itemBottom > container.scrollTop + container.clientHeight) {
                container.scrollTop = itemBottom - container.clientHeight;
            } else if (itemTop < container.scrollTop) {
                container.scrollTop = itemTop;
            }
        }
    };

    highlightMatch = (text, isActive) => {
        const { query } = this.state;
        const regex = new RegExp(`(${query})`, 'i');
        const parts = text.split(regex);
        const color = isActive ? 'white' : 'black';
        return parts.map((part, index) =>
            regex.test(part) ? (
                <strong key={index} style={{ color }}>{part}</strong>
            ) : (
                <span key={index} style={{ color }}>{part}</span>
            )
        );
    };

    render() {
        const { query, suggestions, loading, activeIndex, isOpen } = this.state;
        const { disabled, width = '300px', placeholder = 'Escribe una población' } = this.props;

        return (
            <div
                style={{ position: 'relative', width }}
                ref={this.wrapperRef}
            >
                <input
                    type="text"
                    value={query}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    placeholder={placeholder}
                    disabled={disabled}
                    style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                />
                {loading && <div>Buscando...</div>}
                {isOpen && suggestions.length > 0 && (
                    <ul
                        ref={(el) => (this.suggestionsContainer = el)}
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            background: 'white',
                            border: '1px solid #ccc',
                            margin: 0,
                            padding: 0,
                            listStyle: 'none',
                            maxHeight: '150px',
                            overflowY: 'auto',
                            zIndex: 1000,
                        }}
                    >
                        {suggestions.map((sug, index) => {
                            const isActive = index === activeIndex;
                            const value = sug["nombre"];
                            return (
                                <li
                                    key={index}
                                    style={{
                                        padding: '8px',
                                        cursor: 'pointer',
                                        background: isActive ? '#1890ff' : 'transparent',
                                    }}
                                    onMouseDown={() => this.handleSelect(value)}
                                >
                                    {this.highlightMatch(value, isActive)}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        );
    }
}

InputPoblacion.propTypes = {

    valor: PropTypes.string,                 // valor inicial del input
    onSelect: PropTypes.func,                // callback al seleccionar una población
    disabled: PropTypes.bool,                // deshabilita el input
    width: PropTypes.string,                 // ancho del componente
    debounce: PropTypes.number,              // tiempo de debounce en ms
    placeholder: PropTypes.string,           // texto del placeholder
};

InputPoblacion.defaultProps = {
    valor: '',
    onSelect: null,
    disabled: false,
    width: '300px',
    debounce: 300,
    placeholder: 'Escribe una población',
};

export default InputPoblacion;
